/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SanctioningBodyRouteImport } from './routes/$sanctioningBody'
import { Route as DevRouteImport } from './routes/dev'
import { Route as LiveRouteImport } from './routes/live'
import { Route as DevBannersToastsRouteImport } from './routes/dev.banners-toasts'
import { Route as DevErrorBoundariesRouteImport } from './routes/dev.error-boundaries'
import { Route as DevExportStoryboardRouteImport } from './routes/dev.export-storyboard'
import { Route as DevNotificationsRouteImport } from './routes/dev.notifications'
import { Route as DevRevalidatingRacerRouteImport } from './routes/dev.revalidating-racer'
import { Route as DevWeatherRadarRouteImport } from './routes/dev.weather-radar'
import { Route as RunRunIDRouteImport } from './routes/run/$runID'
import { Route as VerifyEmailKeyRouteImport } from './routes/verify-email.$key'
import { Route as RaceRaceIdPreRaceRouteImport } from './routes/race/$raceId.pre-race'
import { Route as RaceRaceIdPreRaceStatsRouteImport } from './routes/race/$raceId.pre-race-stats'
import { Route as RaceRaceIdSettingsRouteImport } from './routes/race/$raceId.settings'
import { Route as RaceRaceIdStandingsRouteImport } from './routes/race/$raceId.standings'
import { Route as ResetPasswordUidTokenRouteImport } from './routes/reset-password.$uid.$token'
import { Route as SchedulePrintWeekendRouteImport } from './routes/schedule.print.$weekend'
import { Route as SeriesSeriesScheduleRouteImport } from './routes/series/$series.schedule'
import { Route as SeriesSeriesStandingsRouteImport } from './routes/series/$series.standings'
import { Route as RunRunIDWidgetWidgetRouteImport } from './routes/run/$runID.widget.$widget'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SanctioningBodyRoute = SanctioningBodyRouteImport.update({
  id: '/$sanctioningBody',
  path: '/$sanctioningBody',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveRoute = LiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => rootRouteImport,
} as any)
const DevBannersToastsRoute = DevBannersToastsRouteImport.update({
  id: '/banners-toasts',
  path: '/banners-toasts',
  getParentRoute: () => DevRoute,
} as any)
const DevErrorBoundariesRoute = DevErrorBoundariesRouteImport.update({
  id: '/error-boundaries',
  path: '/error-boundaries',
  getParentRoute: () => DevRoute,
} as any)
const DevExportStoryboardRoute = DevExportStoryboardRouteImport.update({
  id: '/export-storyboard',
  path: '/export-storyboard',
  getParentRoute: () => DevRoute,
} as any)
const DevNotificationsRoute = DevNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => DevRoute,
} as any)
const DevRevalidatingRacerRoute = DevRevalidatingRacerRouteImport.update({
  id: '/revalidating-racer',
  path: '/revalidating-racer',
  getParentRoute: () => DevRoute,
} as any)
const DevWeatherRadarRoute = DevWeatherRadarRouteImport.update({
  id: '/weather-radar',
  path: '/weather-radar',
  getParentRoute: () => DevRoute,
} as any)
const RunRunIDRoute = RunRunIDRouteImport.update({
  id: '/run/$runID',
  path: '/run/$runID',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailKeyRoute = VerifyEmailKeyRouteImport.update({
  id: '/verify-email/$key',
  path: '/verify-email/$key',
  getParentRoute: () => rootRouteImport,
} as any)
const RaceRaceIdPreRaceRoute = RaceRaceIdPreRaceRouteImport.update({
  id: '/race/$raceId/pre-race',
  path: '/race/$raceId/pre-race',
  getParentRoute: () => rootRouteImport,
} as any)
const RaceRaceIdPreRaceStatsRoute = RaceRaceIdPreRaceStatsRouteImport.update({
  id: '/race/$raceId/pre-race-stats',
  path: '/race/$raceId/pre-race-stats',
  getParentRoute: () => rootRouteImport,
} as any)
const RaceRaceIdSettingsRoute = RaceRaceIdSettingsRouteImport.update({
  id: '/race/$raceId/settings',
  path: '/race/$raceId/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RaceRaceIdStandingsRoute = RaceRaceIdStandingsRouteImport.update({
  id: '/race/$raceId/standings',
  path: '/race/$raceId/standings',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordUidTokenRoute = ResetPasswordUidTokenRouteImport.update({
  id: '/reset-password/$uid/$token',
  path: '/reset-password/$uid/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SchedulePrintWeekendRoute = SchedulePrintWeekendRouteImport.update({
  id: '/schedule/print/$weekend',
  path: '/schedule/print/$weekend',
  getParentRoute: () => rootRouteImport,
} as any)
const SeriesSeriesScheduleRoute = SeriesSeriesScheduleRouteImport.update({
  id: '/series/$series/schedule',
  path: '/series/$series/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const SeriesSeriesStandingsRoute = SeriesSeriesStandingsRouteImport.update({
  id: '/series/$series/standings',
  path: '/series/$series/standings',
  getParentRoute: () => rootRouteImport,
} as any)
const RunRunIDWidgetWidgetRoute = RunRunIDWidgetWidgetRouteImport.update({
  id: '/widget/$widget',
  path: '/widget/$widget',
  getParentRoute: () => RunRunIDRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$sanctioningBody': typeof SanctioningBodyRoute
  '/dev': typeof DevRouteWithChildren
  '/live': typeof LiveRoute
  '/dev/banners-toasts': typeof DevBannersToastsRoute
  '/dev/error-boundaries': typeof DevErrorBoundariesRoute
  '/dev/export-storyboard': typeof DevExportStoryboardRoute
  '/dev/notifications': typeof DevNotificationsRoute
  '/dev/revalidating-racer': typeof DevRevalidatingRacerRoute
  '/dev/weather-radar': typeof DevWeatherRadarRoute
  '/run/$runID': typeof RunRunIDRouteWithChildren
  '/verify-email/$key': typeof VerifyEmailKeyRoute
  '/race/$raceId/pre-race': typeof RaceRaceIdPreRaceRoute
  '/race/$raceId/pre-race-stats': typeof RaceRaceIdPreRaceStatsRoute
  '/race/$raceId/settings': typeof RaceRaceIdSettingsRoute
  '/race/$raceId/standings': typeof RaceRaceIdStandingsRoute
  '/reset-password/$uid/$token': typeof ResetPasswordUidTokenRoute
  '/schedule/print/$weekend': typeof SchedulePrintWeekendRoute
  '/series/$series/schedule': typeof SeriesSeriesScheduleRoute
  '/series/$series/standings': typeof SeriesSeriesStandingsRoute
  '/run/$runID/widget/$widget': typeof RunRunIDWidgetWidgetRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$sanctioningBody': typeof SanctioningBodyRoute
  '/dev': typeof DevRouteWithChildren
  '/live': typeof LiveRoute
  '/dev/banners-toasts': typeof DevBannersToastsRoute
  '/dev/error-boundaries': typeof DevErrorBoundariesRoute
  '/dev/export-storyboard': typeof DevExportStoryboardRoute
  '/dev/notifications': typeof DevNotificationsRoute
  '/dev/revalidating-racer': typeof DevRevalidatingRacerRoute
  '/dev/weather-radar': typeof DevWeatherRadarRoute
  '/run/$runID': typeof RunRunIDRouteWithChildren
  '/verify-email/$key': typeof VerifyEmailKeyRoute
  '/race/$raceId/pre-race': typeof RaceRaceIdPreRaceRoute
  '/race/$raceId/pre-race-stats': typeof RaceRaceIdPreRaceStatsRoute
  '/race/$raceId/settings': typeof RaceRaceIdSettingsRoute
  '/race/$raceId/standings': typeof RaceRaceIdStandingsRoute
  '/reset-password/$uid/$token': typeof ResetPasswordUidTokenRoute
  '/schedule/print/$weekend': typeof SchedulePrintWeekendRoute
  '/series/$series/schedule': typeof SeriesSeriesScheduleRoute
  '/series/$series/standings': typeof SeriesSeriesStandingsRoute
  '/run/$runID/widget/$widget': typeof RunRunIDWidgetWidgetRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$sanctioningBody': typeof SanctioningBodyRoute
  '/dev': typeof DevRouteWithChildren
  '/live': typeof LiveRoute
  '/dev/banners-toasts': typeof DevBannersToastsRoute
  '/dev/error-boundaries': typeof DevErrorBoundariesRoute
  '/dev/export-storyboard': typeof DevExportStoryboardRoute
  '/dev/notifications': typeof DevNotificationsRoute
  '/dev/revalidating-racer': typeof DevRevalidatingRacerRoute
  '/dev/weather-radar': typeof DevWeatherRadarRoute
  '/run/$runID': typeof RunRunIDRouteWithChildren
  '/verify-email/$key': typeof VerifyEmailKeyRoute
  '/race/$raceId/pre-race': typeof RaceRaceIdPreRaceRoute
  '/race/$raceId/pre-race-stats': typeof RaceRaceIdPreRaceStatsRoute
  '/race/$raceId/settings': typeof RaceRaceIdSettingsRoute
  '/race/$raceId/standings': typeof RaceRaceIdStandingsRoute
  '/reset-password/$uid/$token': typeof ResetPasswordUidTokenRoute
  '/schedule/print/$weekend': typeof SchedulePrintWeekendRoute
  '/series/$series/schedule': typeof SeriesSeriesScheduleRoute
  '/series/$series/standings': typeof SeriesSeriesStandingsRoute
  '/run/$runID/widget/$widget': typeof RunRunIDWidgetWidgetRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$sanctioningBody'
    | '/dev'
    | '/live'
    | '/dev/banners-toasts'
    | '/dev/error-boundaries'
    | '/dev/export-storyboard'
    | '/dev/notifications'
    | '/dev/revalidating-racer'
    | '/dev/weather-radar'
    | '/run/$runID'
    | '/verify-email/$key'
    | '/race/$raceId/pre-race'
    | '/race/$raceId/pre-race-stats'
    | '/race/$raceId/settings'
    | '/race/$raceId/standings'
    | '/reset-password/$uid/$token'
    | '/schedule/print/$weekend'
    | '/series/$series/schedule'
    | '/series/$series/standings'
    | '/run/$runID/widget/$widget'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$sanctioningBody'
    | '/dev'
    | '/live'
    | '/dev/banners-toasts'
    | '/dev/error-boundaries'
    | '/dev/export-storyboard'
    | '/dev/notifications'
    | '/dev/revalidating-racer'
    | '/dev/weather-radar'
    | '/run/$runID'
    | '/verify-email/$key'
    | '/race/$raceId/pre-race'
    | '/race/$raceId/pre-race-stats'
    | '/race/$raceId/settings'
    | '/race/$raceId/standings'
    | '/reset-password/$uid/$token'
    | '/schedule/print/$weekend'
    | '/series/$series/schedule'
    | '/series/$series/standings'
    | '/run/$runID/widget/$widget'
  id:
    | '__root__'
    | '/'
    | '/$sanctioningBody'
    | '/dev'
    | '/live'
    | '/dev/banners-toasts'
    | '/dev/error-boundaries'
    | '/dev/export-storyboard'
    | '/dev/notifications'
    | '/dev/revalidating-racer'
    | '/dev/weather-radar'
    | '/run/$runID'
    | '/verify-email/$key'
    | '/race/$raceId/pre-race'
    | '/race/$raceId/pre-race-stats'
    | '/race/$raceId/settings'
    | '/race/$raceId/standings'
    | '/reset-password/$uid/$token'
    | '/schedule/print/$weekend'
    | '/series/$series/schedule'
    | '/series/$series/standings'
    | '/run/$runID/widget/$widget'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SanctioningBodyRoute: typeof SanctioningBodyRoute
  DevRoute: typeof DevRouteWithChildren
  LiveRoute: typeof LiveRoute
  RunRunIDRoute: typeof RunRunIDRouteWithChildren
  VerifyEmailKeyRoute: typeof VerifyEmailKeyRoute
  RaceRaceIdPreRaceRoute: typeof RaceRaceIdPreRaceRoute
  RaceRaceIdPreRaceStatsRoute: typeof RaceRaceIdPreRaceStatsRoute
  RaceRaceIdSettingsRoute: typeof RaceRaceIdSettingsRoute
  RaceRaceIdStandingsRoute: typeof RaceRaceIdStandingsRoute
  ResetPasswordUidTokenRoute: typeof ResetPasswordUidTokenRoute
  SchedulePrintWeekendRoute: typeof SchedulePrintWeekendRoute
  SeriesSeriesScheduleRoute: typeof SeriesSeriesScheduleRoute
  SeriesSeriesStandingsRoute: typeof SeriesSeriesStandingsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$sanctioningBody': {
      id: '/$sanctioningBody'
      path: '/$sanctioningBody'
      fullPath: '/$sanctioningBody'
      preLoaderRoute: typeof SanctioningBodyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live': {
      id: '/live'
      path: '/live'
      fullPath: '/live'
      preLoaderRoute: typeof LiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/banners-toasts': {
      id: '/dev/banners-toasts'
      path: '/banners-toasts'
      fullPath: '/dev/banners-toasts'
      preLoaderRoute: typeof DevBannersToastsRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/error-boundaries': {
      id: '/dev/error-boundaries'
      path: '/error-boundaries'
      fullPath: '/dev/error-boundaries'
      preLoaderRoute: typeof DevErrorBoundariesRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/export-storyboard': {
      id: '/dev/export-storyboard'
      path: '/export-storyboard'
      fullPath: '/dev/export-storyboard'
      preLoaderRoute: typeof DevExportStoryboardRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/notifications': {
      id: '/dev/notifications'
      path: '/notifications'
      fullPath: '/dev/notifications'
      preLoaderRoute: typeof DevNotificationsRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/revalidating-racer': {
      id: '/dev/revalidating-racer'
      path: '/revalidating-racer'
      fullPath: '/dev/revalidating-racer'
      preLoaderRoute: typeof DevRevalidatingRacerRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/weather-radar': {
      id: '/dev/weather-radar'
      path: '/weather-radar'
      fullPath: '/dev/weather-radar'
      preLoaderRoute: typeof DevWeatherRadarRouteImport
      parentRoute: typeof DevRoute
    }
    '/run/$runID': {
      id: '/run/$runID'
      path: '/run/$runID'
      fullPath: '/run/$runID'
      preLoaderRoute: typeof RunRunIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/$key': {
      id: '/verify-email/$key'
      path: '/verify-email/$key'
      fullPath: '/verify-email/$key'
      preLoaderRoute: typeof VerifyEmailKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/race/$raceId/pre-race': {
      id: '/race/$raceId/pre-race'
      path: '/race/$raceId/pre-race'
      fullPath: '/race/$raceId/pre-race'
      preLoaderRoute: typeof RaceRaceIdPreRaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/race/$raceId/pre-race-stats': {
      id: '/race/$raceId/pre-race-stats'
      path: '/race/$raceId/pre-race-stats'
      fullPath: '/race/$raceId/pre-race-stats'
      preLoaderRoute: typeof RaceRaceIdPreRaceStatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/race/$raceId/settings': {
      id: '/race/$raceId/settings'
      path: '/race/$raceId/settings'
      fullPath: '/race/$raceId/settings'
      preLoaderRoute: typeof RaceRaceIdSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/race/$raceId/standings': {
      id: '/race/$raceId/standings'
      path: '/race/$raceId/standings'
      fullPath: '/race/$raceId/standings'
      preLoaderRoute: typeof RaceRaceIdStandingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$uid/$token': {
      id: '/reset-password/$uid/$token'
      path: '/reset-password/$uid/$token'
      fullPath: '/reset-password/$uid/$token'
      preLoaderRoute: typeof ResetPasswordUidTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule/print/$weekend': {
      id: '/schedule/print/$weekend'
      path: '/schedule/print/$weekend'
      fullPath: '/schedule/print/$weekend'
      preLoaderRoute: typeof SchedulePrintWeekendRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/series/$series/schedule': {
      id: '/series/$series/schedule'
      path: '/series/$series/schedule'
      fullPath: '/series/$series/schedule'
      preLoaderRoute: typeof SeriesSeriesScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/series/$series/standings': {
      id: '/series/$series/standings'
      path: '/series/$series/standings'
      fullPath: '/series/$series/standings'
      preLoaderRoute: typeof SeriesSeriesStandingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/run/$runID/widget/$widget': {
      id: '/run/$runID/widget/$widget'
      path: '/widget/$widget'
      fullPath: '/run/$runID/widget/$widget'
      preLoaderRoute: typeof RunRunIDWidgetWidgetRouteImport
      parentRoute: typeof RunRunIDRoute
    }
  }
}

interface DevRouteChildren {
  DevBannersToastsRoute: typeof DevBannersToastsRoute
  DevErrorBoundariesRoute: typeof DevErrorBoundariesRoute
  DevExportStoryboardRoute: typeof DevExportStoryboardRoute
  DevNotificationsRoute: typeof DevNotificationsRoute
  DevRevalidatingRacerRoute: typeof DevRevalidatingRacerRoute
  DevWeatherRadarRoute: typeof DevWeatherRadarRoute
}

const DevRouteChildren: DevRouteChildren = {
  DevBannersToastsRoute: DevBannersToastsRoute,
  DevErrorBoundariesRoute: DevErrorBoundariesRoute,
  DevExportStoryboardRoute: DevExportStoryboardRoute,
  DevNotificationsRoute: DevNotificationsRoute,
  DevRevalidatingRacerRoute: DevRevalidatingRacerRoute,
  DevWeatherRadarRoute: DevWeatherRadarRoute,
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)

interface RunRunIDRouteChildren {
  RunRunIDWidgetWidgetRoute: typeof RunRunIDWidgetWidgetRoute
}

const RunRunIDRouteChildren: RunRunIDRouteChildren = {
  RunRunIDWidgetWidgetRoute: RunRunIDWidgetWidgetRoute,
}

const RunRunIDRouteWithChildren = RunRunIDRoute._addFileChildren(
  RunRunIDRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SanctioningBodyRoute: SanctioningBodyRoute,
  DevRoute: DevRouteWithChildren,
  LiveRoute: LiveRoute,
  RunRunIDRoute: RunRunIDRouteWithChildren,
  VerifyEmailKeyRoute: VerifyEmailKeyRoute,
  RaceRaceIdPreRaceRoute: RaceRaceIdPreRaceRoute,
  RaceRaceIdPreRaceStatsRoute: RaceRaceIdPreRaceStatsRoute,
  RaceRaceIdSettingsRoute: RaceRaceIdSettingsRoute,
  RaceRaceIdStandingsRoute: RaceRaceIdStandingsRoute,
  ResetPasswordUidTokenRoute: ResetPasswordUidTokenRoute,
  SchedulePrintWeekendRoute: SchedulePrintWeekendRoute,
  SeriesSeriesScheduleRoute: SeriesSeriesScheduleRoute,
  SeriesSeriesStandingsRoute: SeriesSeriesStandingsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
